export default "__VITE_ASSET__8ed643e5__"